import {
	MEMBERSHIP_PRICE_IDS,
	RETIRED_MEMBERSHIP_PRICE_IDS,
} from "@brookbush/types";

type Priced = {
	id: string;
	recurring?: { interval?: string | null } | null;
};

/**
 * Individual membership prices the plan selector and checkout may offer.
 * Each interval shows only its $39 / $399 price when that price is live,
 * otherwise the catalog price. Retired test prices are never offered.
 *
 * @param {T[]} prices - Catalog prices for the individual plan
 * @returns {T[]} Prices to offer
 */
export const selectMembershipPrices = <T extends Priced>(prices: T[]): T[] => {
	const liveIds = new Set(prices.map((price) => price.id));

	return prices.filter((price) => {
		if (RETIRED_MEMBERSHIP_PRICE_IDS.has(price.id)) return false;

		const interval = price.recurring?.interval;
		if (interval !== "month" && interval !== "year") return true;

		const shippedId = MEMBERSHIP_PRICE_IDS[interval];
		return !liveIds.has(shippedId) || price.id === shippedId;
	});
};
